// @ts-nocheck
import React from 'react';
import { Tile, ProgressIndicator, Grid, Column, Tag, Stack, Button } from '@carbon/react';
import { Trophy, Education, Star, Time } from '@carbon/icons-react';

function ProgressTracker() {
  return (
    <div style={{ padding: '0 0 24px', marginLeft: 240 }}>
      <h2 style={{ marginBottom: 24, color: '#1890ff', fontSize: '2rem', fontWeight: 400 }}>My Learning Progress</h2>

      {/* Overall Progress */}
      <Tile style={{ marginBottom: 24 }}>
        <h4 style={{ fontSize: '1.5rem', fontWeight: 400, marginBottom: '16px' }}>Overall Progress</h4>
        <Grid>
          <Column lg={3} md={4} sm={8} xs={16}>
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <Star size={24} style={{ marginBottom: '8px', color: '#52c41a' }} />
              <div style={{ fontSize: '2rem', fontWeight: 600, color: '#52c41a', marginBottom: '4px' }}>12</div>
              <div style={{ fontSize: '0.875rem', color: '#525252' }}>Learning Streak days</div>
            </div>
          </Column>
          <Column lg={3} md={4} sm={8} xs={16}>
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <Time size={24} style={{ marginBottom: '8px', color: '#1890ff' }} />
              <div style={{ fontSize: '2rem', fontWeight: 600, color: '#1890ff', marginBottom: '4px' }}>47.5</div>
              <div style={{ fontSize: '0.875rem', color: '#525252' }}>Total Hours</div>
            </div>
          </Column>
          <Column lg={3} md={4} sm={8} xs={16}>
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <Education size={24} style={{ marginBottom: '8px', color: '#faad14' }} />
              <div style={{ fontSize: '2rem', fontWeight: 600, color: '#faad14', marginBottom: '4px' }}>23</div>
              <div style={{ fontSize: '0.875rem', color: '#525252' }}>Concepts Mastered</div>
            </div>
          </Column>
          <Column lg={3} md={4} sm={8} xs={16}>
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <Trophy size={24} style={{ marginBottom: '8px', color: '#f759ab' }} />
              <div style={{ fontSize: '2rem', fontWeight: 600, color: '#f759ab', marginBottom: '4px' }}>8</div>
              <div style={{ fontSize: '0.875rem', color: '#525252' }}>Achievements earned</div>
            </div>
          </Column>
        </Grid>
      </Tile>

      {/* Subject Progress */}
      <Grid style={{ marginBottom: 24 }}>
        <Column lg={8} md={8} sm={16} xs={16}>
          <Tile style={{ marginBottom: '16px' }}>
            <h5 style={{ fontSize: '1.25rem', fontWeight: 400, marginBottom: '16px' }}>Mathematics</h5>
            <div style={{ marginBottom: 16 }}>
              <Stack>
                <span>Overall Mastery:</span>
                <Tag type="green">78% Complete</Tag>
              </Stack>
              <ProgressIndicator currentIndex={2} />
            </div>

            <div style={{ marginBottom: 12 }}>
              <span style={{ fontWeight: 'bold', color: '#52c41a', fontSize: '12px' }}>✅ RECENT ACHIEVEMENTS</span>
              <div style={{ marginTop: 4 }}>
                <Tag type="green" size="sm">
                  Fractions Mastered
                </Tag>
                <Tag type="green" size="sm">
                  Problem Solving +2
                </Tag>
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <span style={{ fontWeight: 'bold', color: '#1890ff', fontSize: '12px' }}>📚 IN PROGRESS</span>
              <div style={{ marginTop: 4 }}>
                <Tag type="blue" size="sm">
                  Decimal Operations
                </Tag>
                <Tag type="blue" size="sm">
                  Word Problems
                </Tag>
              </div>
            </div>

            <Button kind="ghost" size="sm">
              View Detailed Progress →
            </Button>
          </Tile>
        </Column>

        <Column lg={8} md={8} sm={16} xs={16}>
          <Tile style={{ marginBottom: '16px' }}>
            <h5 style={{ fontSize: '1.25rem', fontWeight: 400, marginBottom: '16px' }}>Science</h5>
            <div style={{ marginBottom: 16 }}>
              <Stack>
                <span>Overall Mastery:</span>
                <Tag color="orange">65% Complete</Tag>
              </Stack>
              <ProgressIndicator percent={65} strokeColor="#52c41a" />
            </div>

            <div style={{ marginBottom: 12 }}>
              <span style={{ fontWeight: 'bold', color: '#52c41a', fontSize: '12px' }}>✅ RECENT ACHIEVEMENTS</span>
              <div style={{ marginTop: 4 }}>
                <Tag color="green" style={{ fontSize: '11px' }}>
                  Cell Structure
                </Tag>
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <span style={{ fontWeight: 'bold', color: '#faad14', fontSize: '12px' }}>⚠️ NEEDS FOCUS</span>
              <div style={{ marginTop: 4 }}>
                <Tag color="orange" style={{ fontSize: '11px' }}>
                  Photosynthesis
                </Tag>
              </div>
            </div>

            <Button type="link" size="small" style={{ padding: 0 }}>
              View Detailed Progress →
            </Button>
          </Tile>
        </Column>
      </Grid>

      <Grid gutter={[16]}>
        <Column xs={24} md={12}>
          <Tile title="Language Arts" style={{ marginBottom: '16px' }}>
            <div style={{ marginBottom: 16 }}>
              <Stack>
                <span>Overall Mastery:</span>
                <Tag color="green">85% Complete</Tag>
              </Stack>
              <ProgressIndicator percent={85} strokeColor="#722ed1" />
            </div>

            <div style={{ marginBottom: 12 }}>
              <span style={{ fontWeight: 'bold', color: '#52c41a', fontSize: '12px' }}>✅ STRONG AREAS</span>
              <div style={{ marginTop: 4 }}>
                <Tag color="green" style={{ fontSize: '11px' }}>
                  Reading Comprehension
                </Tag>
                <Tag color="green" style={{ fontSize: '11px' }}>
                  Vocabulary
                </Tag>
              </div>
            </div>

            <Button type="link" size="small" style={{ padding: 0 }}>
              View Detailed Progress →
            </Button>
          </Tile>
        </Column>

        <Column xs={24} md={12}>
          <Tile title="Social Studies" style={{ marginBottom: '16px' }}>
            <div style={{ marginBottom: 16 }}>
              <Stack>
                <span>Overall Mastery:</span>
                <Tag color="blue">72% Complete</Tag>
              </Stack>
              <ProgressIndicator percent={72} strokeColor="#faad14" />
            </div>

            <div style={{ marginBottom: 12 }}>
              <span style={{ fontWeight: 'bold', color: '#1890ff', fontSize: '12px' }}>📚 CURRENT FOCUS</span>
              <div style={{ marginTop: 4 }}>
                <Tag color="blue" style={{ fontSize: '11px' }}>
                  American History
                </Tag>
                <Tag color="blue" style={{ fontSize: '11px' }}>
                  Geography
                </Tag>
              </div>
            </div>

            <Button type="link" size="small" style={{ padding: 0 }}>
              View Detailed Progress →
            </Button>
          </Tile>
        </Column>
      </Grid>
    </div>
  );
}

export default ProgressTracker;
